import { Component, OnInit, ViewChild } from '@angular/core';
import { GrIrService } from '../../../../service/gr-ir/gr-ir.service';
import { PurchaseOrderService } from '../../../../service/vendor/purchase-order.service';
import { TreeTable } from 'primeng/treetable';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import { GrLineItemFieldsDTO,VendorFieldsDTOForGR,POFieldsDTOForGR,ItemFieldsDTOForSchedule,GRSearchDTO } from '../../../../models/grLineItemSearchDTO';
interface Column {
  field: string;
  defaultFilter: string;
}

@Component({
  selector: 'app-gr-line-item',
  templateUrl: './gr-line-item.component.html',
  styleUrl: './gr-line-item.component.scss'
})

export class GrLineItemComponent implements OnInit{
  @ViewChild('tt') tt?: TreeTable;
  mappedData: any[] = [];

  selectedGrData: any[] = []
  selectedPoData: any[] = [];
  plantList: any[] = [];
  poList: any[] = [];

  grList!: any[];
  cols!: Column[];
  sidebarVisible: boolean = false
  grNo: string = '';
  poNo: string = '';
  GR: string = '';
  limit:number = 10
  currentPage:number=1;
  totalRecords:number=0
  grSearchDTO?:GRSearchDTO
  poFieldsDTOForGR?:POFieldsDTOForGR
  itemFieldsDTOForSchedule?:ItemFieldsDTOForSchedule
  vendorFieldsDTOForGR?:VendorFieldsDTOForGR
  grLineItemFieldsDTO?:GrLineItemFieldsDTO
  isLoading: boolean = false;
  constructor(
    private grIrService: GrIrService,
    private purchaseOrder: PurchaseOrderService,
  ) {
    this.grSearchDTO = new GRSearchDTO()
    this.poFieldsDTOForGR = new POFieldsDTOForGR()
    this.itemFieldsDTOForSchedule = new ItemFieldsDTOForSchedule()
    this.vendorFieldsDTOForGR = new VendorFieldsDTOForGR()
    this.grLineItemFieldsDTO = new GrLineItemFieldsDTO()
  }


  ngOnInit(): void {
    this.fetchData();
    this.initializeColumns();

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
    this.GR = selectedNo;
    this.fetchData().then(() => {
      history.replaceState({ ...history.state, selectedNo: null }, '');
    });
    }
  }
  initializeColumns() {
    this.cols = [
      // { field: 'status', defaultFilter:''},
      { field: 'vendor_code' ,defaultFilter:''},
      { field: 'status' ,defaultFilter:''},
      { field: 'invoice_no' ,defaultFilter:''},
      { field: 'invoice_date' ,defaultFilter:''},
      { field: 'poagreement_no' ,defaultFilter:''},
      { field: 'gr_no' ,defaultFilter:''},
      { field: 'gr_date' ,defaultFilter:''},
      { field: 'gate_entry_no' ,defaultFilter:''},
      { field: 'gate_entry_date' ,defaultFilter:''},
      { field: 'business_name' ,defaultFilter:''},
      { field: 'plant' ,defaultFilter:''},
      { field: 'item_no' ,defaultFilter:''},
      { field: 'material_code' ,defaultFilter:''},
      { field: 'material_description' ,defaultFilter:''},
      { field: 'uom' ,defaultFilter:''},
      { field: 'storage_location' ,defaultFilter:''},
      { field: 'batch_no' ,defaultFilter:''},
      { field: 'quantity' ,defaultFilter:''},
      { field: 'gate_entry_quantity' ,defaultFilter:''},
      { field: 'ok_quantity' ,defaultFilter:''},
      { field: 'reject_quantity' ,defaultFilter:''},
    ];
  }


  onInputChange(event: any, field: string) {
    const inputValue = (event.target as HTMLInputElement)?.value;
    if ("gr_no" == field || "gr_date" == field ||"gate_entry_no" == field ||"plant" == field ||"gate_entry_date" == field ||"invoice_no" == field ||"invoice_date" == field ||"status" == field) {
      (this.grSearchDTO as any)[field] = inputValue;
    }
    else if ("item_no" == field || "quantity" == field) {
      (this.itemFieldsDTOForSchedule as any)[field] = inputValue;
    }
    else if ("poagreement_no" == field ) {
      (this.poFieldsDTOForGR as any)[field] = inputValue;
    }
    else if ("business_name" == field || "vendor_code" == field) {
      (this.vendorFieldsDTOForGR as any)[field] = inputValue;
    }
    else if ("quantity" == field || "batch_no" == field ||  "material_code" == field || "material_description" == field ||  "uom" == field ||  "storage_location" == field ||  "gate_entry_quantity" == field || "ok_quantity" == field || "reject_quantity" == field) {
      (this.grLineItemFieldsDTO as any)[field] = inputValue;
    }
    this.currentPage=1
    this.fetchData()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.fetchData()
  }

  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
    const year = date.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
}


async fetchData() {
  try {
    let data={
      page:this.currentPage,
      limit:this.limit,
      gr_line_item_search_dto:this.grLineItemFieldsDTO,
      gr_search_dto:this.grSearchDTO ,
      po_search_dto:this.poFieldsDTOForGR,
      item_search_dto:this.itemFieldsDTOForSchedule,
      vendor_master_search_dto:this.vendorFieldsDTOForGR,
    }
    this.isLoading=true
    const res = await this.grIrService.getGRLineItem(data);
    this.isLoading=false
    this.grList = res.message.gr_list;
    this.totalRecords = res.message.total_gr
    if (this.grList) {
      this.mappedData = this.grList.map((gr: any, index: any) => {
        return {
          key: `parent_${index}`,
          data: {
            plant: gr.plant,
            gr_no: gr.gr_no,
            vendor_code: gr.vendor_code,
            business_name: gr.business_name,
            gr_date: this.formatDate(gr.gr_date),
            gr_time: gr.gr_time,
            gate_entry_no: gr.gate_entry_no,
            gate_entry_date: this.formatDate(gr.gate_entry_date),
            invoice_no: gr.invoice_no,
            invoice_date: this.formatDate( gr.invoice_date),
            poagreement_no: gr.poagreement_no,
            status: gr.status,
            item_no: gr.item_no,
            material_code: gr.material_code,
            material_description: gr.material_description,
            uom: gr.uom,
            storage_location: gr.storage_location,
            quantity: this.formatNumber(gr.quantity ?? 0),
            batch_no: gr.batch_no,
            gate_entry_quantity: this.formatNumber(gr.gate_entry_quantity ?? 0),
            ok_quantity: this.formatNumber(gr.ok_quantity?? 0),
            reject_quantity: this.formatNumber(gr.reject_quantity ?? 0),
          },
          // children: gr.batch_detail.sort((a: any, b: any) => this.compareItemNo(a.line_item_no, b.line_item_no)).map((item: any, childIndex: any) => ({
          //   key: `child_${index}_${childIndex}`,
          //   data: {
          //     plant: item.po_no,
          //     gr_no: item.line_item_no,
          //     vendor_code: item.gr_material_code,
          //     vendor_name: item.gr_material_description,
          //     gr_date: item.gr_uom,
          //     gr_time: item.gr_storage_location,
          //     // gate_entry_no: item.actual_quantity,
          //     gate_entry_date: item.gr_line_item_quantity,
          //     // invoice_no: item.batch_no,
          //     invoice_date: item.gr_line_item_batch_no,
          //   },
          // })),
        };
      });
    }
    if (this.GR) {
      this.mappedData = this.mappedData.filter(data => data.data.gr_no === this.GR);
    }
  } catch (error) {
    this.isLoading=false
    console.error("Error fetching data:", error);
  }
}
formatNumber(value: any) {
  if (value == null) return '0.00';

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (typeof num !== 'number' || isNaN(num)) return value;

  // Round the number to two decimal places
  const roundedValue = Math.round(num * 100) / 100;

  const strNum = roundedValue.toString();

  // Check if it has trailing zeros after decimal or no decimal point
  if (!strNum.includes('.') || strNum.endsWith('.00')) {
    return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

compareItemNo(a: string, b: string): number {
  const hasUnderscoreA = a.includes('_');
  const hasUnderscoreB = b.includes('_');

  if (hasUnderscoreA && hasUnderscoreB) {
    const [prefixA, numberA] = a.split('_');
    const [prefixB, numberB] = b.split('_');

    const prefixComparison = prefixA.localeCompare(prefixB);

    if (prefixComparison !== 0) {
      return prefixComparison;
    }

    const numberComparison = parseInt(numberA, 10) - parseInt(numberB, 10);
    return numberComparison;
  } else {
    const numericComparison = parseInt(a, 10) - parseInt(b, 10);
    return numericComparison;
  }
}

getSeverity(status: string): string {
  if (!status) {
    return 'info';
  }



  switch (status) {
    case 'Pending For Invoice':
      return 'pendingforinvoice';
    case 'Invoiced':
      return 'invoiced';
    default:
      return 'info';
  }
}

getSeverityClass(severity: string): string {
  switch (severity) {
    case 'pendingforinvoice':
      return 'pendingforinvoice';
    case 'invoiced':
      return 'invoiced';
    default:
      return '';
  }
}

downloadExcel(){
  const formattedData = this.formatDataForExcel(this.grList);
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  const colWidths = this.calculateColumnWidths(formattedData);

  // Set the column widths
  ws['!cols'] = colWidths.map(width => ({ wch: width }));
  XLSX.utils.book_append_sheet(wb, ws, 'PaymentList');
  XLSX.writeFile(wb, 'Gr line item List.xlsx');
}
formatDataForExcel(data: any[]): any[] {
  const formattedData = data.map(payment => ({
    'Status': payment.status,
    'Invoice No': payment.invoice_no,
    'Invoice Date':payment.invoice_date,
    'PO/Agreement No':payment.poagreement_no,
    'GR No':payment.gr_no,
    'GR Date':payment.gr_date,
    'Gate Entry No':payment.gate_entry_no,
    'Gate Entry Date':payment.gate_entry_date,
    'Vendor Code':payment.vendor_code,
    'Vendor Name':payment.business_name,
    'Plant':payment.plant,
    'Line Item No':payment.item_no,
    'Material Code':payment.material_code,
    'Description':payment.material_description,
    'UOM':payment.uom,
    'Storage Location':payment.storage_location,
    'GR Batch No':payment.batch_no,
    'GR Quantity':payment.quantity,
    'Gate Entry Quantity':payment.gate_entry_quantity,
    'OK Quantity':payment.ok_quantity,
    'Reject Quantity':payment.reject_quantity,
  }));
  return formattedData;
}

calculateColumnWidths(data: any[]): number[] {
  const colWidths: number[] = [];
  const keys = Object.keys(data[0]);

  keys.forEach((key, colIndex) => {
      let maxWidth = key.length;
      data.forEach(row => {
          maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
      });
      colWidths[colIndex] = maxWidth + 2;
  });

  return colWidths;
}

}
